import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

export const EloCaretUpIcon: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props}>
    <path d='M17 13L10 6L3 13' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </EloBaseIcon>
)
